import type { IconType } from 'react-icons'
import { NavItem } from '../../../layout/sidebar/NavItem'
import { useMhlScope } from './useMhlScope'

export type MhlScopeRequirement = 'canViewStats' | 'isTeamLeader'

interface Props {
    path: string
    label: string
    Icon: IconType
    /** Which scope flag must be true for the link to render. */
    requires: MhlScopeRequirement
}

/**
 * Sidebar link that only renders when the server-declared MHL scope grants
 * the required flag (team leaders for overview, stats and the agents list).
 * Admins use the admin sidebar, so this is only used in the agent variant.
 */
export const MhlScopedNavItem = ({ path, label, Icon, requires }: Props) => {
    const { scope } = useMhlScope()
    if (!scope?.[requires]) return null
    return <NavItem path={path} label={label} Icon={Icon} />
}
